export default __webpack_public_path__ + "static/old-logo-white-4d2b09f31ab3912cee5abe9735b26cf9.png";